import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';

import { NOTE_REMINDER_FRAGMENT } from '../fragment';
import type { MutationResponse, CreateNoteReminderPayload } from './types';

export const mutationFn = async ({
  customMessage,
  deliveryDate,
  eventBasedReminder,
  noteId,
  userTimezone,
}: CreateNoteReminderPayload) => {
  const { createNoteReminder, errors } =
    await requestWithAuth<MutationResponse>(
      gql`
        mutation CreateNoteReminder(
          $createNoteReminderData: CreateNoteReminderInput!
        ) {
          createNoteReminder(createNoteReminderData: $createNoteReminderData) {
            ...NoteReminderFields
          }
        }
        ${NOTE_REMINDER_FRAGMENT}
      `,
      {
        createNoteReminderData: {
          customMessage,
          deliveryDate,
          eventBasedReminder,
          noteId,
          userTimezone,
        },
      }
    );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return createNoteReminder;
};
